import { Heading } from '@flixbus/honeycomb-react';
import { Icon, IconOffer } from '@flixbus/honeycomb-icons-react';

import { useVoucher } from '../../../context/VoucherProdiver';

import RuleDisplay from '../RuleDisplay';
import { RULE_GROUPS } from './ruleGroups';

import styles from '../voucher-info.module.scss';

const VoucherInfoRules = () => {
  const {
    data: { rules },
  } = useVoucher();

  if (!rules || rules.length === 0) return null;

  return (
    <div className={styles.container}>
      <Heading sectionHeader extraClasses={styles.rulesTitle} size={3}>
        <span className={styles.rulesIcon}>
          <Icon InlineIcon={IconOffer} />
        </span>
        Additional Rules
      </Heading>
      {RULE_GROUPS.map(group => (
        <RuleDisplay key={group.title} title={group.title} fields={group.fields} />
      ))}
    </div>
  );
};

export default VoucherInfoRules;
